import { createApp } from 'vue'
import App from './App.vue'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Icons and fonts
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

// Router
import router from './router.js'

// Bootstrap Vue Next
import { createBootstrap } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

// axios
import axios from 'axios'

// Pinia for state management (replaces vue-session)
import { createPinia } from 'pinia'

// Custom styles
import '@/assets/css/fixed-tooltip-buttons.css'

// Session plugin for backward compatibility
import sessionPlugin from '@/plugins/session'

// Custom Vue 3 compatible JsonExcel component
import JsonExcel from '@/components/JsonExcel.vue'

// v-viewer for Vue 3
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

// Custom components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import UploadProgress from '@/components/UploadProgress.vue'
import DefaultLayout from "@/layouts/DefaultLayout.vue"
import BlankLayout from "@/layouts/BlankLayout.vue"
import FooterContent from "@/components/FooterContent.vue"
import DemoMode from "@/DemoMode.vue"

// Create Vuetify instance
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light'
  }
})

// Create Pinia instance
const pinia = createPinia()

// Create Vue app
const app = createApp(App)

// Configure axios globally
app.config.globalProperties.$http = axios
app.config.globalProperties.CancelToken = axios.CancelToken

// Use plugins
app.use(router)
app.use(vuetify)
app.use(pinia)
app.use(createBootstrap())
app.use(sessionPlugin)
app.use(VueViewer)

// Register global components
app.component("JsonExcel", JsonExcel)
app.component("loading-spinner", LoadingSpinner)
app.component("upload-progress", UploadProgress)
app.component("default-layout", DefaultLayout)
app.component("blank-layout", BlankLayout)
app.component("footer-content", FooterContent)
app.component("demo-mode", DemoMode)

// Mount the app
app.mount('#app')
